import { render, staticRenderFns } from "./UserRightsManagement.vue?vue&type=template&id=bad16326&"
import script from "./UserRightsManagement.vue?vue&type=script&lang=js&"
export * from "./UserRightsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports